/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Staffing API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Which document step a Persona inquiry failed at / progressed to.

Used both to classify how far a candidate got before cancelling and to classify which step a
completed-but-flagged verification's fraud signal came from (selfie vs ID).
 */
export type PersonaCancelStage =
  (typeof PersonaCancelStage)[keyof typeof PersonaCancelStage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PersonaCancelStage = {
  no_upload: 'no_upload',
  id_failed: 'id_failed',
  selfie_failed: 'selfie_failed',
} as const;
